// extracted by mini-css-extract-plugin
export default {"header":"firewall_header__7Y9WH"};